import { Reducer } from "redux";
import { EntitlementAction, EntitlementActionTypes } from "../actions";
import { EntitlementCRMInfo } from "@blacknut/javascript-sdk/dist";
export interface State {
  crmInfo: Record<string, EntitlementCRMInfo>;
}
const initialState: State = {
  crmInfo: {},
};

export const reducer: Reducer<State> = (
  state = initialState,
  action: EntitlementAction,
) => {
  switch (action.type) {
    case EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_SUCCESS: {
      return {
        ...state,
        crmInfo: { ...state.crmInfo, [action.entitlementId]: action.info },
      };
    }
    default:
      return state;
  }
};
